import React from 'react';
import css from './list.module.css';

/** Маркированный список: `[list][item]…[/item][/list]` */
export const List: React.FC<React.PropsWithChildren> = ({children}) => <ul className={css.list}>{children}</ul>;
